import { apiClient } from './apiClient';

const base = '/api/call-campaigns';

export const callCampaignService = {
  list: () => apiClient.get(base),
  create: payload => apiClient.post(base, payload),
  update: (id, payload) => apiClient.put(`${base}/${id}`, payload),
  remove: id => apiClient.del(`${base}/${id}`),
};

export default callCampaignService;

